import { parsePerformer, fixStreamProfilesId, fixPledgeEndTime } from './utils.js';

export function PresenceChannel(config, ws_emitter, ui_emitter, storeController) {

  ws_emitter.addEventListener('presence_login_success', event => {
    const { user } = event.detail;
    console.log('onPresenceLoginSuccess', user);
    storeController.store.dispatch(storeController.user.actions.update_user_from_chat_server(user));
  });

  ws_emitter.addEventListener('presence_login_error', event => {
    const data = event.detail;
    console.error('onPresenceLoginError', data);
    sentryCaptureMessage('presence_login_error', data);
  });

  ws_emitter.addEventListener('presence_login_timeout', event => {
    console.warn('onPresenceLoginTimeout', event.detail.error_message);
  });

  ws_emitter.addEventListener('presence_performers', event => {
    let performers = event.detail.performers;
    performers = performers.map(p => parsePerformer(p, event.detail.server_time));
    storeController.store.dispatch(storeController.performers.actions.receive_performers(performers));
    window.FWC.messenger.restartIfNeeded();
  });

  ws_emitter.addEventListener('presence_join_performer', event => {
    const performer = parsePerformer(event.detail.user, event.detail.server_time);
    storeController.store.dispatch(storeController.performers.actions.performer_join(performer));
  });

  ws_emitter.addEventListener('presence_leave_performer', event => {
    storeController.store.dispatch(storeController.performers.actions.performer_leave(event.detail));
  });

  ws_emitter.addEventListener('presence_change_status_performer', event => {
    storeController.store.dispatch(storeController.performers.actions.performer_change_status(event.detail));
  });

  ws_emitter.addEventListener('presence_vibratip_setting', event => {
    storeController.store.dispatch(storeController.performers.actions.performer_change_vibratip(event.detail));
  });

  ws_emitter.addEventListener('presence_true_private_setting', event => {
    storeController.store.dispatch(storeController.performers.actions.performer_true_private_setting(event.detail));
  });

  ws_emitter.addEventListener('presence_add_stream', event => {
    const user_id = event.detail.user_id;
    const stream = event.detail.stream_config;
    fixStreamProfilesId(stream);
    storeController.store.dispatch(storeController.performers.actions.performer_add_stream({user_id, stream}));
  });

  ws_emitter.addEventListener('presence_delete_stream', event => {
    const user_id = event.detail.user_id;
    const stream_id = event.detail.stream_id;
    storeController.store.dispatch(storeController.performers.actions.performer_delete_stream({user_id, stream_id}));
    if (user_id == null && stream_id == null) {
      // delete all streams for all performers
      storeController.store.dispatch(storeController.performers.actions.all_performers_delete_streams());
    }
  });

  ws_emitter.addEventListener('presence_answer_private_chat_invitation', event => {
    const accepted = event.detail.accepted;
    const performer = event.detail.user;
    if (!accepted) ui_emitter.dispatchEvent(new CustomEvent('performer_private_show_decline', {detail: {performer}}));
  });

  ws_emitter.addEventListener('presence_user_account_info', event => {
    // tokens, tier_level, displayname
    const info = event.detail.account_info;
    if ('tokens' in info) {
      window.FWC.updateUserTokens(info.tokens);
    }
    if ('tier_level' in info) {
      window.FWC.updateUserTierLevel(info.tier_level);
    }
  });

  ws_emitter.addEventListener('presence_my_pledge_bids', event => {
    const myBids = {};
    const { pledge_bids } = event.detail;
    if (pledge_bids) {
      for (let i=0; i<pledge_bids.length; i++) {
        const b = pledge_bids[i];
        b.user_id = parseInt(b.user_id);
        myBids[b.user_id] = b;
      }
    }
    storeController.store.dispatch(storeController.pledgeBids.actions.pledgeBids(myBids));
  });

  ws_emitter.addEventListener('presence_pledge_bid_success', event => {
    const { user_id, tokens, tokens_left } = event.detail;
    window.FWC.updateUserTokens(tokens_left);
    storeController.store.dispatch(storeController.pledgeBids.actions.pledgeBidAdded({user_id, tokens}));
  });

  ws_emitter.addEventListener('presence_pledge_bid_error', event => {
    const { user_id, error_message } = event.detail;
    console.error(error_message);
    sentryCaptureMessage('presence_pledge_bid_error', event.detail);
  });

  ws_emitter.addEventListener('presence_pledge_bid_refund', event => {
    const { user_id, tokens } = event.detail;
    const { user } = storeController.store.getState();
    const newTokens = user.tokens + tokens;
    window.FWC.updateUserTokens(newTokens);
  });

  ws_emitter.addEventListener('presence_im_chat_info', event => {
    const { im_chat_info, collocutor, initiator_id } = event.detail;
    window.FWC.messenger.onImChatInfo(im_chat_info, collocutor, initiator_id);
  });

}
